type LatencyListener = (avgMs: number) => void;

const MAX_SAMPLES = 8;
const samples: number[] = [];
const listeners = new Set<LatencyListener>();

function getAverage(): number {
  if (samples.length === 0) return 0;
  const sum = samples.reduce((a, b) => a + b, 0);
  return Math.round(sum / samples.length);
}

export function recordLatency(ms: number) {
  samples.push(ms);
  if (samples.length > MAX_SAMPLES) {
    samples.shift();
  }
  const avg = getAverage();
  listeners.forEach((fn) => fn(avg));
}

export function getLatency(): number | null {
  return samples.length > 0 ? getAverage() : null;
}

export function onLatency(listener: LatencyListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
